module.exports = __webpack_public_path__ + "img/9S.49a7c52e.png";